import { createPreviewExport } from '@fusion-advantage/formlib'
import { Export } from '@fusion-advantage/backcompat'
import { AppRootState } from './appStore'

export const selectIsPreviewMode = (state: AppRootState): boolean => {
	return state.app.preview !== null
}

// null until the branch info has been read from the flowmap
export const selectPreviewExport = (state: AppRootState): Export|null => {
	const preview = state.app.preview
	if(!preview?.branchInfo) {
		return null
	}
	return createPreviewExport({
		branchGuid: preview.branchGuid,
		...preview.branchInfo,
	})
}
